/* eslint-disable react-hooks/exhaustive-deps */
import { useAppDispatch } from "@/store";
import {
  fetchRelatedProductBySlug,
  selectProduct,
} from "@/store/slices/product";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Swiper, SwiperSlide } from "swiper/react";
import heart from "../../../../public/img/heart1.png";
import features11 from "../../../assets/images/b3.jpg";
import styles from "./similar.module.scss";
import ProductCard from "@/components/product-card/product-card";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import { getCookie } from "cookies-next";
import { unbxdTrackEvent, unbxdTrackMultipleEvent } from "@/lib/unbxd";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

const ProductDetailsSimilar = ({ product }: any) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const productState = useSelector(selectProduct);
  const [data, setData] = useState<any>([]);
  const [title, setTitle] = useState("");
  const [requestId, setrequestId] = useState(
    product?.headers?.["unbxd-request-id"]
  );

  useEffect(() => {
    // dispatch(fetchRelatedProductBySlug(router.query.slug as string));
    recommended();
  }, []);
  const recommended = async () => {
    const products =
      product.data.widget1?.recommendations.map((product: any) => ({
        id: product?.productId,
        title: product?.title,
        slug: product?.productUrl.split("/")[
          product?.productUrl.split("/").length - 1
        ],
        sku: product?.uniqueId,
        try_online: product?.hasTryOnline?.toLowerCase() === "true",
        image: product?.imageUrl[0],
        priceId: product.variantId,
        price: product?.price,
        discount: {
          total: product?.discount ? product?.sellingPrice : null,
          name: product?.discountLabel || null,
          price: product?.discount ? product?.sellingPrice : null,
          text: product?.discountLabel || null,
        },
        fastDelivery: product?.vIsFastDelivery?.toLowerCase() === "true",
        // deal_of_the_day: null,
        categories: [{ name: product.categoryPath1[0] }],
        // trending: null,
        // featured: null,
        // recomemded: null,
        best_seller: product?.isBestSeller?.toLowerCase() === "true",
        new_arrival: product?.isNewArrival?.toLowerCase() === "true",
      })) || [];
    setData(products);
    setTitle(product.data.widget1.widgetTitle);
    if (products.length) {
      const payload = {
        requestId: requestId,
        pids_list: products.map((v: any) => v.sku),
        experience_pagetype: "PRODUCT",
        experience_widget: "WIDGET1",
      };
      unbxdTrackEvent("experience_impression", payload);
    }
  };
  return (
    <>
      {!!data.length && (
        <div className={styles.similar_products}>
          <h2>{title}</h2>
          <Swiper
            className="swiper-navigation-black"
            navigation={false}
            spaceBetween={10}
            slidesPerView={2}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }}
          >
            {data?.map((product: any) => (
              <SwiperSlide key={product.id}>
                <div className={styles.jwellery}>
                  <ProductCard
                    product={product}
                    unbxd={{
                      isunbxd: true,
                      requestId: requestId,
                      experience_pagetype: "PRODUCT",
                      experience_widget: "WIDGET1",
                    }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  );
};

export default ProductDetailsSimilar;
